"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasetMappersApi = exports.DatasetMappersApiFactory = exports.DatasetMappersApiFp = exports.DatasetMappersApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * DatasetMappersApi - axios parameter creator
 * @export
 */
const DatasetMappersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {DatasetStringValueMapperDTO} [datasetStringValueMapperDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetMapperResourceCreateDatasetMapper: (datasetStringValueMapperDTO_1, ...args_1) => __awaiter(this, [datasetStringValueMapperDTO_1, ...args_1], void 0, function* (datasetStringValueMapperDTO, options = {}) {
            const localVarPath = `/dataset-mappers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(datasetStringValueMapperDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetMapperResourceDeleteDatasetMapper: (id_1, ...args_2) => __awaiter(this, [id_1, ...args_2], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('datasetMapperResourceDeleteDatasetMapper', 'id', id);
            const localVarPath = `/dataset-mappers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<number> | null} [ids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetMapperResourceGetAllDatasetMappers: (ids_1, ...args_3) => __awaiter(this, [ids_1, ...args_3], void 0, function* (ids, options = {}) {
            const localVarPath = `/dataset-mappers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetMapperResourceGetDatasetMapperById: (id_2, ...args_4) => __awaiter(this, [id_2, ...args_4], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('datasetMapperResourceGetDatasetMapperById', 'id', id);
            const localVarPath = `/dataset-mappers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {DatasetStringValueMapperDTO} [datasetStringValueMapperDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetMapperResourceUpdateDatasetMapper: (id_3, datasetStringValueMapperDTO_2, ...args_5) => __awaiter(this, [id_3, datasetStringValueMapperDTO_2, ...args_5], void 0, function* (id, datasetStringValueMapperDTO, options = {}) {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('datasetMapperResourceUpdateDatasetMapper', 'id', id);
            const localVarPath = `/dataset-mappers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(datasetStringValueMapperDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.DatasetMappersApiAxiosParamCreator = DatasetMappersApiAxiosParamCreator;
/**
 * DatasetMappersApi - functional programming interface
 * @export
 */
const DatasetMappersApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DatasetMappersApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {DatasetStringValueMapperDTO} [datasetStringValueMapperDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetMapperResourceCreateDatasetMapper(datasetStringValueMapperDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetMapperResourceCreateDatasetMapper(datasetStringValueMapperDTO, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetMappersApi.datasetMapperResourceCreateDatasetMapper']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetMapperResourceDeleteDatasetMapper(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetMapperResourceDeleteDatasetMapper(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetMappersApi.datasetMapperResourceDeleteDatasetMapper']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<number> | null} [ids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetMapperResourceGetAllDatasetMappers(ids, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetMapperResourceGetAllDatasetMappers(ids, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetMappersApi.datasetMapperResourceGetAllDatasetMappers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetMapperResourceGetDatasetMapperById(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetMapperResourceGetDatasetMapperById(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetMappersApi.datasetMapperResourceGetDatasetMapperById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {DatasetStringValueMapperDTO} [datasetStringValueMapperDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetMapperResourceUpdateDatasetMapper(id, datasetStringValueMapperDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetMapperResourceUpdateDatasetMapper(id, datasetStringValueMapperDTO, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetMappersApi.datasetMapperResourceUpdateDatasetMapper']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.DatasetMappersApiFp = DatasetMappersApiFp;
/**
 * DatasetMappersApi - factory interface
 * @export
 */
const DatasetMappersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DatasetMappersApiFp)(configuration);
    return {
        /**
         *
         * @param {DatasetMappersApiDatasetMapperResourceCreateDatasetMapperRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetMapperResourceCreateDatasetMapper(requestParameters = {}, options) {
            return localVarFp.datasetMapperResourceCreateDatasetMapper(requestParameters.datasetStringValueMapperDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetMappersApiDatasetMapperResourceDeleteDatasetMapperRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetMapperResourceDeleteDatasetMapper(requestParameters, options) {
            return localVarFp.datasetMapperResourceDeleteDatasetMapper(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetMappersApiDatasetMapperResourceGetAllDatasetMappersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetMapperResourceGetAllDatasetMappers(requestParameters = {}, options) {
            return localVarFp.datasetMapperResourceGetAllDatasetMappers(requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetMappersApiDatasetMapperResourceGetDatasetMapperByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetMapperResourceGetDatasetMapperById(requestParameters, options) {
            return localVarFp.datasetMapperResourceGetDatasetMapperById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetMappersApiDatasetMapperResourceUpdateDatasetMapperRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetMapperResourceUpdateDatasetMapper(requestParameters, options) {
            return localVarFp.datasetMapperResourceUpdateDatasetMapper(requestParameters.id, requestParameters.datasetStringValueMapperDTO, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DatasetMappersApiFactory = DatasetMappersApiFactory;
/**
 * DatasetMappersApi - object-oriented interface
 * @export
 * @class DatasetMappersApi
 * @extends {BaseAPI}
 */
class DatasetMappersApi extends base_1.BaseAPI {
    /**
     *
     * @param {DatasetMappersApiDatasetMapperResourceCreateDatasetMapperRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetMappersApi
     */
    datasetMapperResourceCreateDatasetMapper(requestParameters = {}, options) {
        return (0, exports.DatasetMappersApiFp)(this.configuration).datasetMapperResourceCreateDatasetMapper(requestParameters.datasetStringValueMapperDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetMappersApiDatasetMapperResourceDeleteDatasetMapperRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetMappersApi
     */
    datasetMapperResourceDeleteDatasetMapper(requestParameters, options) {
        return (0, exports.DatasetMappersApiFp)(this.configuration).datasetMapperResourceDeleteDatasetMapper(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetMappersApiDatasetMapperResourceGetAllDatasetMappersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetMappersApi
     */
    datasetMapperResourceGetAllDatasetMappers(requestParameters = {}, options) {
        return (0, exports.DatasetMappersApiFp)(this.configuration).datasetMapperResourceGetAllDatasetMappers(requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetMappersApiDatasetMapperResourceGetDatasetMapperByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetMappersApi
     */
    datasetMapperResourceGetDatasetMapperById(requestParameters, options) {
        return (0, exports.DatasetMappersApiFp)(this.configuration).datasetMapperResourceGetDatasetMapperById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetMappersApiDatasetMapperResourceUpdateDatasetMapperRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetMappersApi
     */
    datasetMapperResourceUpdateDatasetMapper(requestParameters, options) {
        return (0, exports.DatasetMappersApiFp)(this.configuration).datasetMapperResourceUpdateDatasetMapper(requestParameters.id, requestParameters.datasetStringValueMapperDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DatasetMappersApi = DatasetMappersApi;
//# sourceMappingURL=dataset-mappers-api.js.map